import Vue from 'vue'
import Vuex from 'vuex'
import { axiospost } from 'utils/axiosMethods'
import router from '@/router'
import {
  dynamicRoutes,
  visualizeRoute,
  fireStationRoute,
  visualizeWrjRoute,
  visualizeWrj2Route,
  spacerBarRoute,
  pumpMonitorRoute,
  waterSystemRoute,
  waterSystemHomeRoute
} from '@/router'
import continuing from './modules/continuing'
import visualize from './modules/visualize'
import deviceList from './modules/gotparams'
import Dictionary from './modules/Dictionary'
import home from './modules/home'
import wbhtgl from './modules/wbhtgl'

Vue.use(Vuex)

const store = new Vuex.Store({
  // ...
  state: {
    user: JSON.parse(localStorage.getItem('user')),
    theme: localStorage.getItem('theme') || 'blue',
    loginSuper: JSON.parse(localStorage.getItem('loginSuper')),
    menu: [],
    // 存储从后台获取权限的菜单数据
    menuList: [],
    permissionList: [],
    userAreaList: [],
    startSocket: false,
    isHasVisualize: false,
    isHasFireStation: false,
    isHasDroneVisualize: false,
    isHasDroneVisualize2: false,
    isHasSpacerBar: false,
    isHasPumpMonitor: false,
    isHasWaterSystem: false,
    isHasWaterSystemHome: false,
    historyAlarm: []
  },
  getters: {},
  mutations: {
    changeTheme(state, payload) {
      state.theme = payload
    },
    filterMenuList(state, resolve) {
      let data
      if (localStorage.getItem('loginSuper')) {
        let json = JSON.parse(localStorage.getItem('loginSuper'))
        let { id, isAdmin, phone, name } = json
        data = { id, isAdmin, phone, name }
      } else if (localStorage.getItem('user')) {
        let json = JSON.parse(localStorage.getItem('user'))
        let { id, isAdmin, status, phone, name } = json
        data = { id, isAdmin, status, phone, name }
      }
      if (data) {
        axiospost('operation/permission/findPermission', {
          ...data
        }).then(res => {
          let menuList = res.data.data.menuList
          state.menuList = menuList
          function filterRoutes(routes) {
            return routes.filter(r => {
              let m = menuList.find(it => it === r.name)
              if (m && r.children) {
                r.children = filterRoutes(r.children)
              } else {
                r.children = []
              }
              return !!m
            })
          }
          resolve(filterRoutes(dynamicRoutes))
        })
      }
    },
    filterCommonRouter(state, { mark, resolve }) {
      let data
      if (localStorage.getItem('loginSuper')) {
        let json = JSON.parse(localStorage.getItem('loginSuper'))
        let { id, isAdmin, phone, name } = json
        data = { id, isAdmin, phone, name }
      } else if (localStorage.getItem('user')) {
        let json = JSON.parse(localStorage.getItem('user'))
        let { id, isAdmin, status, phone, name } = json
        data = { id, isAdmin, status, phone, name }
      }
      if (data) {
        if (state.menuList.length) {
          function filterRouters() {
            return mark.filter(r => {
              let m = state.menuList.find(it => it === r.name)
              return !!m
            }).length
          }
          resolve(filterRouters())
        }
      }
    },
    SET_Visualize(state, data) {
      state.isHasVisualize = data
    },
    SET_FireStation(state, data) {
      state.isHasFireStation = data
    },
    SET_DroneVisualize(state, data) {
      state.isHasDroneVisualize = data
    },
    SET_DroneVisualize2(state, data) {
      state.isHasDroneVisualize2 = data
    },
    SET_SpacerBar(state, data) {
      state.isHasSpacerBar = data
    },
    SET_PumpMonitor(state, data) {
      state.isHasPumpMonitor = data
    },
    SET_WaterSystem(state, data) {
      state.isHasWaterSystem = data
    },
    SET_WaterSystemHome(state, data) {
      state.isHasWaterSystemHome = data
    },
    SET_MENU(state, menu) {
      state.menu = menu
    },
    SET_USER(state, user) {
      state.user = user
    },
    SET_LoginSuper(state, loginSuper) {
      state.loginSuper = loginSuper
    },
    SET_History_Alarm(state, historyAlarm) {
      state.historyAlarm = historyAlarm
    },
    loginOut(state) {
      state.menu = []
      state.user = []
      localStorage.removeItem('companyId')
      localStorage.removeItem('user')
      localStorage.removeItem('loginSuper')
      localStorage.removeItem('username')
      localStorage.removeItem('token')
      localStorage.removeItem('userId')
      localStorage.removeItem('userphone')
      sessionStorage.removeItem('startSocket')
    },
    changeUser(state, name) {
      state.username = name
      localStorage.setItem('username', name)
    },
    SET_SOCKET(state, trige) {
      state.startSocket = trige
    },
    SET_USER_AREA(state, list) {
      state.userAreaList = list
    }
  },
  actions: {
    async addRoutes({ commit, state }) {
      /*  获取后台给的权限数组 */
      /*  根据后台权限跟我们定义好的权限对比，筛选出对应的路由并加入到path=''的children */
      const permissionList = state.menu.length
        ? state.menu
        : await new Promise(resolve => commit('filterMenuList', resolve))

      // 创建路由检查辅助函数
      const checkRoute = routes =>
        new Promise(resolve => commit('filterCommonRouter', { mark: routes, resolve }))

      // 并行检查所有路由权限
      const [
        isHasVisualize,
        isHasFireStation,
        isHasDroneVisualize,
        isHasDroneVisualize2,
        isHasSpacerBar,
        isHasPumpMonitor,
        isHasWaterSystem,
        isHasWaterSystemHome
      ] = await Promise.all([
        checkRoute(visualizeRoute),
        checkRoute(fireStationRoute),
        checkRoute(visualizeWrjRoute),
        checkRoute(visualizeWrj2Route),
        checkRoute(spacerBarRoute),
        checkRoute(pumpMonitorRoute),
        checkRoute(waterSystemRoute),
        checkRoute(waterSystemHomeRoute)
      ])

      // 批量设置状态
      commit('SET_Visualize', !!isHasVisualize)
      commit('SET_FireStation', !!isHasFireStation)
      commit('SET_DroneVisualize', !!isHasDroneVisualize)
      commit('SET_DroneVisualize2', !!isHasDroneVisualize2)
      commit('SET_SpacerBar', !!isHasSpacerBar)
      commit('SET_PumpMonitor', !!isHasPumpMonitor)
      commit('SET_WaterSystem', !!isHasWaterSystem)
      commit('SET_WaterSystemHome', !!isHasWaterSystemHome)

      if (isHasVisualize) router.addRoutes(visualizeRoute)
      if (isHasFireStation) {
        router.addRoutes(fireStationRoute)
      }
      if (isHasDroneVisualize) {
        router.addRoutes(visualizeWrjRoute)
      }
      
      if (isHasDroneVisualize2) {
        router.addRoutes(visualizeWrj2Route)
      }
      if (isHasSpacerBar) router.addRoutes(spacerBarRoute)
      if (isHasPumpMonitor) router.addRoutes(pumpMonitorRoute)
      if (isHasWaterSystem) router.addRoutes(waterSystemRoute)
      if (isHasWaterSystemHome) router.addRoutes(waterSystemHomeRoute)

      /* 生成左侧导航菜单 */
      commit('SET_MENU', permissionList)
      /*  动态添加路由 */
      router.addRoutes(permissionList)
    }
  },
  modules: {
    continuing,
    visualize,
    deviceList,
    Dictionary,
    home,
    wbhtgl
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js